module.exports = __webpack_public_path__ + "static/media/0b371d95-cef3-309c-0783-7dfc0a6d54d4.8c2e5816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0b371d95-cef3-309c-0783-7dfc0a6d54d4.jpg
// module id = 3075
// module chunks = 1